import { createTheming, ThemingType } from '@callstack/react-theme-provider';

import { DEFAULT_THEME } from '@/config';
import { Theme } from '@/types';
import { themes } from '@/utils/helpers';

const { ThemeProvider, useTheme }: ThemingType<Theme> = createTheming(themes[DEFAULT_THEME]);

export { ThemeProvider, useTheme };
